export default defineNuxtPlugin(() => {
  const { trackEvent } = useTracking();
  const router = useRouter();

  router.afterEach(() => {
    trackEvent("page_view", "view");
  });
});
